import React from "react"
import { GatsbyImage } from "gatsby-plugin-image"
import { useStaticQuery, graphql } from "gatsby"
import { updateInternalSearchSessionStorage } from "components/page-components/Internal-Search/utils"

export const NoResults = ({ setSearchState, set_focussed }) => {
  const { image } = useStaticQuery(graphql`
    query {
      image: file(
        relativePath: { eq: "illustrations/general/no-result-white.png" }
      ) {
        childImageSharp {
          gatsbyImageData(
            width: 550
            formats: [AUTO, AVIF]
            layout: CONSTRAINED
            placeholder: BLURRED
          )
        }
      }
    }
  `)
  const initial_search_state = {
    distinct: true,
    refinementList: {
      scope: ["website", "notice"],
      type: ["news", "page", "lexicon", "blog", "author", "notice"],
      tags: [],
    },
    query: "",
  }
  const clear_all = () => {
    updateInternalSearchSessionStorage({
      focussed: false,
      last_search_state: initial_search_state,
    })
    setSearchState(initial_search_state)
    set_focussed(false)
  }

  return (
    <div style={{ height: "60%" }} className="is-flex">
      <div className="m-auto">
        <GatsbyImage
          image={image.childImageSharp.gatsbyImageData}
          alt="Keine Ergebnisse"
        />
        <p className="title is-4 has-text-white mt-5 has-text-centered">
          Tut mir Leid, ich habe nichts passendes gefunden.
        </p>
        <div className="has-text-centered">
          <button className="is-white-20 button" onClick={clear_all}>
            Suche zurücksetzen
          </button>
        </div>
      </div>
    </div>
  )
}
